import axios from "axios";
import Config from "../../../config";

const v2_actionDeletarContato = (id) => {

    return axios({
        method: "delete",
        url: `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v2/cadastro/contatos/${id}/deletar`
    });
};

export default v2_actionDeletarContato;
